import { render, staticRenderFns } from "./ThankYouHero.vue?vue&type=template&id=2fc29052&scoped=true"
import script from "./ThankYouHero.vue?vue&type=script&lang=js"
export * from "./ThankYouHero.vue?vue&type=script&lang=js"
import style0 from "./ThankYouHero.vue?vue&type=style&index=0&id=2fc29052&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc29052",
  null
  
)

export default component.exports